import { render, staticRenderFns } from "./productcenter.vue?vue&type=template&id=d75f6526&scoped=true&"
import script from "./productcenter.vue?vue&type=script&lang=js&"
export * from "./productcenter.vue?vue&type=script&lang=js&"
import style0 from "./productcenter.vue?vue&type=style&index=0&id=d75f6526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75f6526",
  null
  
)

export default component.exports